module.exports = __webpack_public_path__ + "static/img/sample_02.7381829.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sample_02.jpg
// module id = zbWb
// module chunks = 1